<template>
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="30" height="30" fill="white" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.5 29.1428C1.57812 29.1428 1.65625 29.1272 1.73438 29.0803L9.23438 25.0803C9.39063 25.0022 9.5 24.8303 9.5 24.6428V1.64282C9.5 1.3772 9.26562 1.14282 9 1.14282C8.92188 1.14282 8.84375 1.15845 8.76563 1.20532L1.26562 5.20532C1.10938 5.28345 1 5.45532 1 5.64282V28.6428C1 28.9084 1.23438 29.1428 1.5 29.1428ZM21 29.1428C21.0781 29.1428 21.1562 29.1272 21.2343 29.0803L28.7343 25.0803C28.8906 25.0022 29 24.8303 29 24.6428V1.64282C29 1.3772 28.7656 1.14282 28.5 1.14282C28.4218 1.14282 28.3437 1.15845 28.2656 1.20532L20.7656 5.20532C20.6093 5.28345 20.5 5.45532 20.5 5.64282V28.6428C20.5 28.9084 20.7343 29.1428 21 29.1428ZM19.5001 28.6428C19.5001 28.9084 19.2657 29.1428 19.0001 29.1428C18.922 29.1428 18.8438 29.1272 18.7813 29.0959L10.7813 25.0959C10.6095 25.0022 10.5001 24.8303 10.5001 24.6428V1.64282C10.5001 1.3772 10.7345 1.14282 11.0001 1.14282C11.0782 1.14282 11.1563 1.15845 11.2188 1.1897L19.2188 5.1897C19.3907 5.28345 19.5001 5.45532 19.5001 5.64282V28.6428Z"
            fill="#5B74FF"
        />
    </svg>
</template>

<script>
export default {
    name: 'LsLogo',
};
</script>
